export const NOTIFICATION_LOADED = 'NOTIFICATION_LOADED';
export const NOTIFCATION_SEEN = 'NOTIFCATION_SEEN';
